module.exports = __webpack_public_path__ + "static/media/Sec-4_2677_Background.cfac6b47.jpg";